// Modules
import * as Yup from 'yup'

// Application
import { IsSequential } from 'utils'

export const CreatePasswordSchema = Yup.object().shape({
    password: Yup.string()
        .required('Campo obrigatório')
        .test(
            'password sequential',
            'Não use números ou letras sequenciais',
            (value: string): boolean => Boolean(value) && !IsSequential(value),
        )
        .test(
            'password min-length',
            'Para continuar, sua senha precisa ter no mínimo 8 caracteres',
            (value: string): boolean => Boolean(value) && value.length >= 8,
        )
        .test(
            'password max-length',
            'Você atingiu o limite de 40 caracteres, diminua para continuar',
            (value: string): boolean => Boolean(value) && value.length <= 40,
        ),

    confirmPassword: Yup.string()
        .oneOf([Yup.ref('password'), null], 'Senhas diferentes. Reveja e tente novamente para continuar')
        .required('Campo obrigatório'),
})
